import PageEvent from "../../../../src/components/page-event";
import * as React from 'react';
export default {
  PageEvent,
  React
};